import React from 'react';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { Recognition } from './components/Recognition';
import { CostOfStaying } from './components/CostOfStaying';
import { SystemPhases } from './components/SystemPhases';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-full bg-cream-50" data-id="element-0" data-mp="2wk0a329kipw1">
      <TopBar data-id="element-1" data-mp="2wj8e3qc26q58" />
      <Hero data-id="element-2" data-mp="2wip5j08ate3v" />
      <main data-id="element-3" data-mp="2whxaprmizken">
        <Recognition data-id="element-4" data-mp="28ufqch5lbolp" />
        <CostOfStaying data-id="element-5" data-mp="28tw44o8wqe1v" />
        <SystemPhases data-id="element-6" data-mp="28t4lee0esat0" />
        <Volumes data-id="element-7" data-mp="28sl5t3y8dyi5" />
        <Bonuses data-id="element-8" data-mp="28s2z1ddy01vz" />
        <Offer data-id="element-9" data-mp="23vktwcepa1j4" />
        <Testimonials data-id="element-10" data-mp="23w4drynwuzzs" />
        <Guarantee data-id="element-11" data-mp="23utcc5hxu4bu" />
        <Faq data-id="element-12" data-mp="23t8i6gzjcnei" />
        <FinalCta data-id="element-13" data-mp="23ti5txx3yih1" />
      </main>
      <Footer data-id="element-14" data-mp="3ikqzm1my986s" />
    </div>;
}